<template>
  <v-card-text>
    <v-row>
      <v-col cols="12">
        <exo-display-configuration-summary
          :missionManager="missionManager"
          :results="results"
        />
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import Vue from 'vue'

let displayObjectCommon = {
  props: {
    missionManager: Object,
    results: Object,
    expand: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    getColor(index) {
      return this.getCardColors()[index]
    },
    getCardColors() {
      return [
        '#ff948c',
        '#ffb58c',
        '#ffd18c',
        '#8cffff',
        '#8ce7ff',
        '#8cceff',
        '#938cff',
        '#c78cff',
        '#ff8ca8',
        '#ff8c8c',
        '#a5ffd9'
      ]
    }
  }
}

Vue.component('exo-display-configuration-summary', {
  mixins: [displayObjectCommon],
  props: {},

  data() {
    return { type: 'configuration-summary' }
  },

  computed: {
    header() {
      return this.results.header
    }
  },

  template: `
  <exo-simu-display-card :label="'Launch sequences : ' + header" colorIndex="10" :expand="true">
    <div class="ml-3" v-for="(launchConfiguration, index1) in results.launchConfigurations" :key="index1">
          <v-col cols="12">
          <b>{{(index1 + 1) + ':   ' }}</b>
          <template v-for="summary in launchConfiguration.summary.split('<br/>')">
            {{ summary}} <br/>
            </template>
          <ul>
            <li v-for="(launch, index2) in launchConfiguration.bookings" :key="index1 + '-' + index2">
            {{ launch.summary }}
            </li>
          </ul>
          </v-col>


      <v-divider class="m-0" ></v-divider>
    </div>



  </exo-simu-display-card>
   `
})

Vue.component('exo-simu-display-card', {
  mixins: [displayObjectCommon],

  props: ['label', 'colorIndex', 'expand'],

  data() {
    return {
      expandPanel: this.expand
    }
  },

  template: `
  <v-col m-2>
    <v-card height="100%">
      <div v-bind:style="{ 'background-color': getColor(colorIndex)}"  style="height: 10px"></div>
      <v-card-title class="black--text">
        <h5>{{ label }}</h5>
        <v-spacer></v-spacer>
        <v-btn icon v-on:click="expandPanel = !expandPanel">
          <v-icon color="grey darken-1" v-if="expandPanel">expand_less</v-icon>
          <v-icon color="grey darken-1" v-if="!expandPanel">expand_more</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="m-0" v-if="expandPanel"></v-divider>
      <v-list v-if="expandPanel" dense class="p-0">
         <slot></slot>
      </v-list>
    </v-card>
  </v-col>
  `
})

export default {
  name: 'deployment-result-display',

  props: ['missionManager', 'results'],

  computed: {},

  data() {
    return {}
  }
}
</script>
